(function($) {
  $.fn.moneyField = function() {
    $(this).each(function () {
      var element = this;
      if (!element.closest(".editortable table, table.editortable")) {
        var symbol = element.hasAttribute('data-no-symbol') ? '' : '$';
        $(element).autoNumeric('init', { aSign: symbol, vMin: '-999999999.99' });
      }
    });
  };
})(jQuery);
